/**
 * @param {string} searchString
 * @constructor
 */
export function SearchHistory(searchString) {
    this.searchString = searchString;
    this.addTime = Date.now();
}
